<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="16"
    viewBox="0 0 20 16"
    fill="none"
  >
    <path
      d="M18.6667 12H16.42C15.7977 13.3004 14.8854 14.4407 13.7533 15.3333H18.6667C19.0203 15.3333 19.3594 15.1929 19.6095 14.9428C19.8595 14.6928 20 14.3536 20 14V13.3333C20 12.9797 19.8595 12.6406 19.6095 12.3905C19.3594 12.1405 19.0203 12 18.6667 12ZM18.6667 8H17.3333C17.3316 9.14023 17.1191 10.2703 16.7067 11.3333H18.6667C19.0203 11.3333 19.3594 11.1929 19.6095 10.9428C19.8595 10.6928 20 10.3536 20 10V9.33333C20 8.97971 19.8595 8.64057 19.6095 8.39052C19.3594 8.14048 19.0203 8 18.6667 8ZM18.6667 4H16.42C16.9293 5.04456 17.2391 6.17505 17.3333 7.33333H18.6667C19.0203 7.33333 19.3594 7.19286 19.6095 6.94281C19.8595 6.69276 20 6.35362 20 6V5.33333C20 4.97971 19.8595 4.64057 19.6095 4.39052C19.3594 4.14048 19.0203 4 18.6667 4ZM8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346629 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0ZM10.6667 6H7.33334C7.15653 6 6.98696 6.07024 6.86193 6.19526C6.73691 6.32029 6.66667 6.48986 6.66667 6.66667C6.66667 6.84348 6.73691 7.01305 6.86193 7.13807C6.98696 7.26309 7.15653 7.33333 7.33334 7.33333H8.66667C9.1971 7.33333 9.70581 7.54405 10.0809 7.91912C10.456 8.29419 10.6667 8.8029 10.6667 9.33333C10.6667 9.86377 10.456 10.3725 10.0809 10.7475C9.70581 11.1226 9.1971 11.3333 8.66667 11.3333V12.6667H7.33334V11.3333H5.33334V10H8.66667C8.84348 10 9.01305 9.92976 9.13807 9.80474C9.2631 9.67971 9.33334 9.51014 9.33334 9.33333C9.33334 9.15652 9.2631 8.98695 9.13807 8.86193C9.01305 8.7369 8.84348 8.66667 8.66667 8.66667H7.33334C6.8029 8.66667 6.2942 8.45595 5.91912 8.08088C5.54405 7.70581 5.33334 7.1971 5.33334 6.66667C5.33334 6.13623 5.54405 5.62753 5.91912 5.25245C6.2942 4.87738 6.8029 4.66667 7.33334 4.66667V3.33333H8.66667V4.66667H10.6667V6Z"
      :fill="color"
    />
  </svg>
</template>
<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  props: {
    color: {
      type: String,
      default: "white",
    },
    withGradient: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    fill(): string {
      return this.withGradient ? "url(#gradient)" : "white"
    },
  },
})
</script>

<!-- <style lang="scss" scoped>

</style> -->
